import { ImgIconProps } from "../types";

export const ImgIcon = ({ src }: ImgIconProps) => (
    <div>
        <img src={`/img/resources/${src}`} alt={src} width="100%" height="auto" />
    </div>
);
